import React from "react";
import { Link } from "react-router-dom";
import logoIcon from "../assets/matrixos/logo-icon.png";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="relative z-10 border-t border-white/8 bg-[#030913]/90 text-slate-300 backdrop-blur-xl">
      <div className="mx-auto max-w-7xl px-6 py-12">
        <div className="grid gap-10 md:grid-cols-[1.2fr_.8fr_.8fr]">
          <div>
            <div className="flex items-center gap-3">
              <img src={logoIcon} alt="MATRIXOS" className="h-12 w-12 object-contain" />
              <div>
                <div className="text-xl font-black tracking-[0.18em] text-white">MATRIXOS</div>
                <div className="text-[11px] uppercase tracking-[0.35em] text-cyan-200/80">platform // powered by neo</div>
              </div>
            </div>
            <p className="mt-5 max-w-xl text-base leading-7 text-slate-400">
              MatrixOS is the platform story. Neo is the live operations engine. Morphius Count is the stock intelligence layer — all inside one system built for real-world operations.
            </p>
          </div>

          <div>
            <div className="text-sm font-semibold uppercase tracking-[0.32em] text-cyan-200">Explore</div>
            <div className="mt-4 flex flex-col gap-3 text-sm">
              <a href="/#neo" className="transition hover:text-cyan-300">Neo</a>
              <Link to="/morphius-count" className="transition hover:text-cyan-300">Morphius Count</Link>
              <a href="/#modes" className="transition hover:text-cyan-300">Industry Modes</a>
              <Link to="/book-demo" className="transition hover:text-cyan-300">Book Demo</Link>
              <Link to="/login" className="transition hover:text-cyan-300">Sign In</Link>
            </div>
          </div>

          <div>
            <div className="text-sm font-semibold uppercase tracking-[0.32em] text-cyan-200">Company</div>
            <div className="mt-4 flex flex-col gap-3 text-sm">
              <Link to="/contact" className="transition hover:text-cyan-300">Contact</Link>
              <Link to="/faq" className="transition hover:text-cyan-300">FAQ</Link>
              <Link to="/terms" className="transition hover:text-cyan-300">Terms</Link>
              <Link to="/privacy" className="transition hover:text-cyan-300">Privacy</Link>
              <Link to="/billing" className="transition hover:text-cyan-300">Billing</Link>
            </div>
          </div>
        </div>

        <div className="mt-10 border-t border-white/8 pt-5 text-sm text-slate-500">
          © {year} MATRIXOS. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
